import { type TagListResponse } from '@air/api/types';
import { createAction } from '@reduxjs/toolkit';

export const selectTagAction = createAction<{ tagId: TagListResponse['id'] }>('SELECT_TAG_ACTION');
export const unselectTagAction = createAction<{ tagId: TagListResponse['id'] }>('UNSELECT_TAG_ACTION');
export const clearSelectedTagsAction = createAction('CLEAR_SELECTED_TAGS');
